var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsCloseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6093 -1.40195e-07C15.8648 -1.17852e-07 16.1226 0.0715369 16.353 0.221168C16.9849 0.63238 17.164 1.47828 16.7522 2.11012L11.6266 9.98428L16.9772 17.8683C17.4004 18.4919 17.2383 19.3411 16.6141 19.7643C15.9904 20.1876 15.1412 20.0254 14.7175 19.4012L8.85731 10.7668C8.54877 10.3119 8.54276 9.71615 8.84257 9.25524L14.4641 0.620365C14.7257 0.218437 15.1631 -1.79199e-07 15.6093 -1.40195e-07Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.98718 -1.40195e-07C7.24276 -1.17852e-07 7.50051 0.0715369 7.73097 0.221168C8.3628 0.63238 8.54192 1.47828 8.13016 2.11012L3.0045 9.98428L8.35515 17.8683C8.77838 18.4919 8.61619 19.3411 7.992 19.7643C7.36836 20.1876 6.51918 20.0254 6.09595 19.4012L0.235787 10.7663C-0.0727569 10.3114 -0.0787631 9.71561 0.221044 9.2547L5.84202 0.620365C6.1036 0.218437 6.54102 -1.79199e-07 6.98718 -1.40195e-07Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsCloseArrow);
export default __webpack_public_path__ + "static/media/settingsCloseArrow.8ac92a1b123f2519d172d8dc406152c0.svg";
export { ForwardRef as ReactComponent };